import { Component } from '@angular/core';

@Component({
  selector: 'allas-banner-principal-limpiaparabrisas',
  imports: [],
  template: `
    <!-- Desktop Version -->
    <section
      class="hidden md:grid grid-cols-12 bg-cover bg-center bg-no-repeat"
      style="background-image: url('/images/services/cambio-limpiaparabrisas/banner-principal-cambio-limpiaparabrisas.webp');"
    >
      <div
        class="flex flex-col gap-2 col-span-6 p-6 xl:p-12 justify-center items-center"
      >
        <main class="flex flex-col gap-2">
          <div class="flex flex-col items-start xl:items-center">
            <span
              class="text-black text-lg xl:text-5xl font-extrabold fs-condensed"
            >
              INSTALACIÓN GRATIS DE
            </span>
            <span
              class="text-allasRed text-lg xl:text-6xl -skew-x-6 font-extrabold fs-condensed mt-6 xl:mt-0"
            >
              LIMPIAPARABRISAS
            </span>
          </div>
          <p class="text-appBlack text-xs xl:text-lg fs-condensed text-center">
            En ALLAS Repuestos realizamos la instalación profesional <br />
            de tus limpiaparabrisas. Rápido, seguro y con garantía.
          </p>
          <div class="flex flex-col xl:flex-row gap-2 self-center mt-6">
            <a
              href="/encuentra-tu-tienda"
              class="text-xs xl:text-base bg-gray-900 text-white px-4 py-2 rounded-md fs-condensed hover:scale-105 transition-all duration-300"
            >
              SOLICITAR INSTALACIÓN
            </a>
          </div>
        </main>
      </div>
    </section>

    <!-- Mobile Version -->
    <section
      class="md:hidden grid grid-cols-12 bg-cover bg-center bg-no-repeat min-h-[60vh] relative"
      style="background-image: url('/images/services/cambio-limpiaparabrisas/banner-principal-cambio-limpiaparabrisas_mobile.webp'); background-size: cover;"
    >
      <!-- Textos arriba -->
      <div
        class="flex flex-col gap-2 col-span-12 p-4 justify-start items-center pt-8"
      >
        <main class="flex flex-col gap-2 w-full items-center">
          <div class="flex flex-col items-center">
            <span class="text-[#302929] text-4xl font-extrabold fs-condensed">
              INSTALACIÓN GRATIS DE
            </span>
            <span
              class="text-allasRed text-4xl -skew-x-6 font-extrabold fs-condensed mt-2"
            >
              LIMPIAPARABRISAS
            </span>
          </div>
          <p class="text-appBlack text-sm fs-condensed text-center">
            En ALLAS Repuestos realizamos la instalación <br />
            profesional de tus limpiaparabrisas. <br />
            Rápido, seguro y con garantía.
          </p>
        </main>
      </div>

      <!-- Botón abajo a la izquierda -->
      <div class="absolute bottom-4 left-4">
        <a
          href="/encuentra-tu-tienda"
          class="text-xs bg-gray-900 text-white px-3 py-2 rounded-md fs-condensed hover:scale-105 transition-all duration-300"
        >
          SOLICITAR INSTALACIÓN
        </a>
      </div>
    </section>
  `,
})
export class BannerPrincipalLimpiaparabrisas {}
